import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('dha_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('dha_token');
      localStorage.removeItem('dha_role');
      localStorage.removeItem('dha_name');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const loginUser = (data) => api.post('/auth/login', data);

export const getDoctors = () => api.get('/doctors');
export const addDoctor = (data) => api.post('/doctors', data);
export const updateDoctor = (id, data) => api.put(`/doctors/${id}`, data);
export const deleteDoctor = (id) => api.delete(`/doctors/${id}`);

export const registerPatient = (data) => api.post('/register', data);
export const searchPatients = (q) => api.get(`/patients?q=${encodeURIComponent(q)}`);

export const getDailyList = (date) => api.get(`/visits${date ? `?date=${date}` : ''}`);

export const getDashboardStats = () => api.get('/dashboard');

export const getAppointments = (params) => api.get('/appointments', { params });
export const createAppointment = (data) => api.post('/appointments', data);
export const cancelAppointment = (id) => api.delete(`/appointments/${id}`);
export const updateAppointmentStatus = (id, status) => api.patch(`/appointments/${id}/status`, { status });

export const markVisitPayment = (id, status) => api.patch(`/visits/${id}/payment`, { status });

export const getReports = (from, to) => api.get(`/reports?from=${from}&to=${to}`);

export default api;
